module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment"
  }, [(_vm.busy) ? _c('icon', {
    attrs: {
      "name": "refresh",
      "scale": "3",
      "spin": "spin"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "href": _vm.comment.permalink,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.comment.title))])]), _c('div', {
    staticClass: "quote"
  }, [_c('blockquote', {
    domProps: {
      "innerHTML": _vm._s(_vm.decodeHtml(_vm.comment.text))
    }
  })], 1), _c('div', {
    staticClass: "comment__foot"
  }, [_c('div', [_c('span', [_vm._v("~ ")]), _c('a', {
    attrs: {
      "href": ("https://reddit.com/u/" + (_vm.comment.author)),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.comment.author))])]), _c('div', [_c('ul', {
    staticClass: "sendoff"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": _vm.comment.context,
      "target": "_blank"
    }
  }, [_vm._v("[article]")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-873c54c0"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RedditComment.vue
// module id = 1084
// module chunks = 1